import { render } from "./RoundButton.vue?vue&type=template&id=0004cdcc&scoped=true"
import script from "./RoundButton.vue?vue&type=script&lang=js"
export * from "./RoundButton.vue?vue&type=script&lang=js"

import "./RoundButton.vue?vue&type=style&index=0&id=0004cdcc&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0004cdcc"]])

export default __exports__